var map = {
	"./Internship.jpg": 9194,
	"./Logo.png": 330,
	"./angular.png": 3301,
	"./banner.png": 7679,
	"./bootstrap.png": 8926,
	"./coding_img.png": 3574,
	"./css.png": 1303,
	"./datajpa.png": 2769,
	"./django.png": 5681,
	"./flask.png": 7423,
	"./gen-ai.png": 3945,
	"./git.png": 8477,
	"./hibernate.png": 8118,
	"./html.png": 5963,
	"./java.png": 1783,
	"./javaScript.png": 8280,
	"./jquery.png": 1776,
	"./msme-logo.png": 5282,
	"./mysql.png": 8279,
	"./python.png": 7600,
	"./spring-ai.png": 5337,
	"./spring.png": 6370,
	"./webtechnologies.png": 6166,
	"./xworkz-certificate.png": 4081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8070;